import styled from "styled-components";

export const Wrapper = styled.div`
  gap: 12px;
  .col {
    flex: 1;
  }
  .icon-attachment {
    max-width: 20px;
 
    display: flex;
  
    align-items: center;
}
  .action-icons {
    gap: 12px;
    height: 42px;
    flex: 0 0 52px;
  }
  .icon-trash,
  .icon-add-more {
    border: none;
    background-color: transparent;
    position: relative;
    width: 18px;
    height: 18px;
  }
  .icon-add-more {
    &:before,
    &:after {
      content: "";
      width: 16px;
      height: 2px;
      border-radius: 1px;
      background-color: rgb(129, 129, 130);
      position: absolute;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      margin: auto;
    }
    &:after {
      width: 2px;
      height: 16px;
    }
  }
 
`;
